import { render, staticRenderFns } from "./WithdrawDataSection.vue?vue&type=template&id=2348f524&"
import script from "./WithdrawDataSection.vue?vue&type=script&lang=js&"
export * from "./WithdrawDataSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports